import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fontsource/inter";

import { Provider } from "mobx-react";
import React from "react";
import ReactDOM from "react-dom/client";

import { App } from "./App";
import store from "./lib/data/store";
import reportWebVitals from "./reportWebVitals";

require("@openfonts/montserrat_all");

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
